var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import * as React from 'react';
function SvgSearch(props) {
    return (React.createElement("svg", __assign({ viewBox: '0 0 20 20' }, props),
        React.createElement("g", { fillRule: 'evenodd' },
            React.createElement("path", { d: 'M19.126 18.037a.75.75 0 11-1.036 1.084l-6.145-5.872a.75.75 0 011.036-1.085l6.145 5.873z' }),
            React.createElement("path", { d: 'M7.816.5a7.316 7.316 0 100 14.632A7.316 7.316 0 007.816.5zm0 1.5a5.816 5.816 0 110 11.632A5.816 5.816 0 017.816 2z' }))));
}
export default SvgSearch;
//# sourceMappingURL=Search.js.map